module.exports = __webpack_public_path__ + "img/top-bg-home.0da17132.jpg";